import { getConfig } from "lib/get-config";
import { appendTrackingParams } from "lib/tracking/params";

export function getBuyUrl() {
  const { art, user } = getConfig();
  const hash = user ? "#buy_now_reg" : "#buy_now_noreg";
  return appendTrackingParams(`/${art}${hash}`);
}
